// Shopify's Cookie Banner API; no consent is changed just by opening preferences.
let bannerLoading;
async function showPreferences() {
  if (!window.privacyBanner?.showPreferences) {
    bannerLoading ||= new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
    await bannerLoading;
  }
  await window.privacyBanner.showPreferences();
}

document.querySelectorAll('[data-cookie-preferences]').forEach((link) => {
  link.addEventListener('click', async (event) => {
    event.preventDefault();
    try {
      await showPreferences();
    } catch {
      bannerLoading = undefined;
      window.location.assign(link.href);
    }
  });
});
